import { Directive, Input, TemplateRef } from '@angular/core';

export interface TabState<T> {
  title: T;
  warn?: boolean;
}

@Directive({
  selector: '[modeDatasetOverviewTab]',
})
export class DatasetOverviewTabDirective<T> {
  @Input() modeDatasetOverviewTab!: TabState<T>;
  constructor(public templateRef: TemplateRef<unknown>) {}
}
